import { config } from "core/config/app";
import SearchRecipeNative from "./pages/SearchRecipeNative";

const router = [
  {
    name: "SEARCH_RECIPES_NATIVE",
    exact: true,
    path: `${config?.basename}/search-recipes-native`,
    element: <SearchRecipeNative />,
    title: "Search Recipe Sqlite",
  },  
];
export default router;

